import SubSectionFields from "../components/SubSectionFields";
import * as actions from "../actions/";
import { StoreState } from "../types/index";
import { connect } from "react-redux";
import { Dispatch } from "redux";

export function mapStateToProps({ query, columns }: StoreState.All) {
  return {
    // fields: ui.fields,
    displayFields: query.displayFields,
    columns: columns,
    // detailSection: ui.filterPanelDetailSection
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onCheck: (newDisplayFields: string[]) =>
      dispatch(actions.addDisplayFields(newDisplayFields)),

    onRemoveCheck: (removedField: string) =>
      dispatch(actions.removeDisplayFields(removedField)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubSectionFields);
